import React from 'react'

import { ColorTrailText } from '@/components/ui/color-trail-text'
import { cn } from '@/utilities/ui'

export type HeadingBodySplitSectionProps = {
  bodyParagraphs: string[]
  className?: string
  headingAfter?: React.ReactNode
  headingId: string
  highlightTrail?: boolean
  titleBeforeHighlight: string
  titleHighlight: string
}

export const HeadingBodySplitSection: React.FC<HeadingBodySplitSectionProps> = ({
  bodyParagraphs,
  className,
  headingAfter,
  headingId,
  highlightTrail = true,
  titleBeforeHighlight,
  titleHighlight,
}) => {
  return (
    <div className={cn('flex flex-col gap-8 lg:flex-row lg:items-start lg:justify-between', className)}>
      {/* Avoid cn()/twMerge on the heading — it strips the custom `text-title` class against `text-*` utilities */}
      <div className="min-w-0 max-w-[44rem]">
        <ColorTrailText
          as="h2"
          className="text-title min-w-0 break-words font-semibold leading-none tracking-[-0.04em] text-bluetext lg:text-balance"
          id={headingId}
          segments={[
            {
              finalColor: 'var(--brand-bluetext)',
              text: titleBeforeHighlight,
              trail: false,
            },
            {
              finalColor: 'var(--brand-dark-green)',
              text: titleHighlight,
              trail: highlightTrail,
            },
          ]}
        />
        {headingAfter}
      </div>

      <div className="max-w-[50rem] shrink-0 space-y-6 font-outfit text-base leading-6 text-black/80">
        {bodyParagraphs.map((paragraph, index) => (
          <p key={index}>{paragraph}</p>
        ))}
      </div>
    </div>
  )
}

